import { useState, useCallback } from 'react'
import { transcriptionService } from '../services/transcriptionService'
import { useAuth } from '../context/AuthContext'

export const useAudioUpload = () => {
  const [isUploading, setIsUploading] = useState(false)
  const [uploadProgress, setUploadProgress] = useState(0)
  const [error, setError] = useState(null)
  const { user } = useAuth()

  const uploadFile = useCallback(async (file) => {
    if (!user) {
      throw new Error('用户未登录')
    }

    setIsUploading(true)
    setUploadProgress(0)
    setError(null)

    try {
      // 创建转录任务（包含文件上传）
      const transcription = await transcriptionService.createTranscription(file, user.id)
      
      // 启动转录处理
      await transcriptionService.startTranscription(transcription.id, transcription.audio_file_path)
      
      setUploadProgress(100)
      return transcription
    } catch (err) {
      console.error('上传失败:', err)
      setError(err.message || '上传失败')
      throw err
    } finally {
      setIsUploading(false)
    }
  }, [user])

  const reset = useCallback(() => {
    setIsUploading(false)
    setUploadProgress(0)
    setError(null)
  }, [])

  return {
    uploadFile,
    isUploading,
    uploadProgress,
    error,
    reset
  }
}